<template>
    <Modal 
      v-model="val"
      :width="800"
      class-name="policies-modal"
      :title="data.title"
    >
      <div v-if="val">
<iframe :src="data.url" frameborder="0" width="100%" height="100%">
</iframe>

     <!--    <object :data="data.url" type="application/pdf" width="100%" height="100%">
            <embed :src="data.url" type="application/pdf" />
        </object> -->
      </div>
    <div slot="footer" />
  </Modal>
</template>

<script>
  import { Modal } from 'iview';

  export default {
    components: { Modal },
    props: {
      value: {
        type: Boolean,
        default: true
      },
      data: {
        type: Object,
        default: {}
      }
    },
    computed: {
      val: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    }
  };
</script>